<!-- <p-datepicker 
    (onSelect)="customCalendarDatesChanged()"
    [(ngModel)]="dateSelected"
    [showTime]="false"
    [yearNavigator]="true"
    view="date"
    yearRange="2000:2030"
    [formControl]="formControl"
    [ngStyle]="{'width': '100%'}">
</p-datepicker> -->

<p-datepicker 
    (onSelect)="customCalendarDatesChanged()"
    [(ngModel)]="dateSelected"
    [showTime]="false"
    view="date"
    yearRange="2000:2030"
    [formControl]="formControl"
    [ngStyle]="{'width': '100%'}">
</p-datepicker>
       